module.exports = __webpack_public_path__ + "img/orn_peq_right.8517456b.svg";